export const getBaseUrl = () => {
  const hrefParts = window.location.href.split('?');
  const baseUrl = hrefParts[0];
  if (baseUrl.slice(-1) === '/') {
    return baseUrl;
  }
  return baseUrl + '/';
};
